import cn from 'classnames';
import { type FC } from 'react';

// styles
import dibsCss from 'dibs-css';
import styles from './PdpRespMarketplaceLoadingCarousel.scss';

type Props = {
    titleClassName?: string;
};

export const PdpRespMarketplaceLoadingCarousel: FC<Props> = ({ titleClassName }) => (
    <div className={cn(dibsCss.flex, dibsCss.flexCol, dibsCss.mbLarger)}>
        <span
            className={cn(
                styles.animate,
                titleClassName,
                dibsCss.mbMedium,
                dibsCss.hLarge,
                dibsCss.w300px,
                dibsCss.roundedSmall
            )}
        />
        <div className={cn(dibsCss.flex, dibsCss.justifyBetween, dibsCss.pxLarge)}>
            {[1, 1, 1, 1, 1].map((_, index) => (
                <div
                    key={index}
                    className={cn(
                        dibsCss.wFull,
                        dibsCss.h280px,
                        dibsCss.mxMedium,
                        styles.animate,
                        dibsCss.roundedSmall
                    )}
                />
            ))}
        </div>
    </div>
);
